const ar = {
  services: {
    resume_parser: 'محلل السيرة الذاتية',
    resume_score: 'مطابق السيرة الذاتية',
    resume_review: 'فحص السيرة الذاتية',
    company_data: 'بيانات الشركة',
    profile_data: 'بيانات الملف الشخصي',
    youtube_keywords: 'أداة كلمات مفتاحية لليوتيوب',
    youtube_suggestions: 'اقتراحات يوتيوب',
    youtube_title: 'مولد عناوين يوتيوب',
    youtube_description: 'مولد أوصاف يوتيوب',
    youtube_hashtags: 'هاشتاجات يوتيوب',
    magical_resume_score: 'مطابق السيرة الذاتية السحري',
    youtube_seo: 'تحسين محركات البحث لليوتيوب',
    'youtube-title': 'مولد عناوين يوتيوب',
    'youtube-description': 'مولد أوصاف يوتيوب',
    'youtube-hashtags': 'هاشتاجات يوتيوب',
    'resume-parser': 'محلل السيرة الذاتية',
    'resume-score': 'درجة السيرة الذاتية',
    'resume-review': 'مراجعة السيرة الذاتية',
    'company-data': 'بيانات الشركة',
    'profile-data': 'بيانات الملف الشخصي',
    'youtube-keywords': 'أداة كلمات مفتاحية لليوتيوب',
    'youtube-suggestions': 'اقتراحات يوتيوب',
    'magical-resume_score': 'درجة السيرة الذاتية السحرية',
    'youtube-seo': 'تحسين محركات البحث لليوتيوب',
  },
  global: {
    copied: 'تم النسخ',
    usage: 'الاستخدام',
    go_to_website: 'اذهب إلى الموقع',
    beta: 'Beta',
    try_it_now: 'جرب الآن',
    all_services: 'جميع الخدمات',
    more_details: 'المزيد من التفاصيل',
    upgrade: 'ترقية',
    yearly: 'سنويًا',
    save: 'حفظ',
    monthly: 'شهريًا',
    playground: 'منطقة التجربة',
    subscribed: 'مشترك',
    unsubscribed: 'غير مشترك',
    documentation: 'التوثيق',
    history: 'السجل',
    clear: 'مسح',
    copy: 'نسخ',
    copy_data: 'نسخ البيانات',
    clear_data: 'مسح البيانات',
    accepted_file_types: 'أنواع الملفات المقبولة:',
    install_chrome_extension: 'تثبيت إضافة كروم',
    extension: 'الإضافة',
    examples: 'أمثلة',
    examples_text: 'ماذا تحتاج الآن؟',
    profile: 'الملف الشخصي',
    select_language: 'اختر اللغة',
    dark_light: 'الوضع المظلم / الفاتح',
    services_playground: 'منطقة التجربة للخدمات',
    upgrade_to: 'الترقية إلى',
    pro: 'محترف',
    basic: 'أساسي',
    free: 'مجاني',
    learn_more: 'تعلم المزيد',
    upgrade_api: 'قم بالترقية إلى الخطة المحترفة للوصول إلى مفتاح API',
  },
  support: {
    support: 'الدعم',
    access_api: 'الوصول إلى API',
  },
  home: {
    wellcome_first: 'مرحبًا بك في',
    wellcome_second: 'منطقة تجربة MagicalAPI',
  },
  home_panel: {
    my_services_title: 'خدماتي',
    drag_reorder_hint:
      'اسحب لإعادة الترتيب • انقر على + لإضافة المزيد من الخدمات',
  },
  alert: {
    verified_email:
      'للحصول على 50 رصيدًا مجانًا، قم بتأكيد عنوان بريدك الإلكتروني. تم إرسال رابط التحقق إلى بريدك الإلكتروني. لم تتلقى رسالة؟',
    magical_resume_score_alert:
      'إذا كانت حقل URL LinkedIn فارغًا، ستبحث هذه الخدمة عن URL في ملف السيرة الذاتية. إذا تم العثور على الرابط، سيتم حساب الدرجة بناءً على البيانات من السيرة الذاتية وLinkedIn.',
    forgot_password: 'لقد أرسلنا رابط إعادة تعيين كلمة المرور الخاصة بك!',
    been_verified_email: 'تم تأكيد بريدك الإلكتروني',
    email_verification_failed: 'فشل التحقق من البريد الإلكتروني',
    start_text: 'يمكنك البدء في استكشاف خدمات MagicalAPI:',
    resume_parser_alert:
      'نقدم أفضل دعم لدينا لملفات السيرة الذاتية باللغة الإنجليزية والفرنسية. يرجى ملاحظة أنه بالنسبة للغات الأخرى، لا يمكننا ضمان نفس مستوى الجودة في الردود.',
  },
  navbar: {
    beta: 'بيتا',
    logout: 'تسجيل الخروج',
    login: 'تسجيل الدخول',
    sign_up: 'إنشاء حساب',
    pricing: 'الأسعار',
    all_services: 'جميع الخدمات',
    panel: 'لوحة التحكم',
    playground: 'منطقة التجربة',
    website: 'الموقع الإلكتروني',
  },
  button_text: {
    back_home: 'العودة إلى الصفحة الرئيسية',
    submit: 'إرسال',
    resend: 'إعادة الإرسال',
    reset: 'إعادة التعيين',
    login: 'تسجيل الدخول',
    sign_up: 'إنشاء حساب',
    send: 'إرسال',
    proceed_to_payment: 'المتابعة إلى الدفع',
    request_more_credit: 'شراء أرصدة',
    payment: 'دفع',
    back: 'الرجوع',
    next: 'التالي',
    find_keywords: 'البحث عن كلمات مفتاحية',
    extract_data: 'استخراج البيانات',
    generate: 'إنشاء',
    generate_title: 'إنشاء العناوين',
    generate_keywords: 'إنشاء الكلمات المفتاحية',
    generate_captions: 'إنشاء العناوين التوضيحية',
    generate_hashtags: 'إنشاء الهاشتاجات',
    calculate_score: 'حساب الدرجة',
    seo_checkup: 'فحص SEO',
    scan_my_resume: 'مسح سيرتي الذاتية',
    revoke: 'إلغاء',
    view_invoice: 'عرض الفاتورة',
    buy_now: 'شراء الآن',
  },
  layout_playground: {
    get_ideas: 'احصل على أفكار',
    get_answer: 'احصل على إجابة',
    empty_title: 'أجب عن المطالبات',
    empty_text:
      'احصل على أفضل النتائج من خلال تجربة مدخلات متعددة وبطول مختلف.',
    get_code: 'هل تريد استخدامه في الكود؟',
    please_wait: 'يرجى الانتظار',
    please_wait_text_first: 'قد يستغرق هذا بعض الوقت.',
    please_wait_text_second: 'شكرًا على الانتظار',
    usege_credit: 'الأرصدة المستخدمة',
    try_it_now: 'جربه الآن',
    learn_more: 'تعلم المزيد',
  },
  sign_up: {
    linkHelperText: 'تسجيل الدخول الآن',
    linkHelperMessage: 'هل لديك حساب بالفعل؟',
    title: 'إنشاء حساب',
    input_email_placeholder: 'البريد الإلكتروني',
    input_first_name_placeholder: 'الاسم الأول',
    input_Last_name_placeholder: 'اسم العائلة',
    input_password_placeholder: 'كلمة المرور',
    input_confirem_password_placeholder: 'تأكيد كلمة المرور',
    required_email: 'البريد الإلكتروني مطلوب',
    required_password: 'كلمة المرور مطلوبة',
    required_last_name: 'اسم العائلة مطلوب',
    required_first_name: 'الاسم الأول مطلوب',
    inValid_email: 'البريد الإلكتروني غير صالح',
    lenght_password: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
    required_confirem_password: 'تأكيد كلمة المرور مطلوب',
    password_not_match: 'تأكيد كلمة المرور غير متطابق',
    i_agree_with: 'أوافق على',
    terms: 'الشروط',
    and: 'و',
    policies: 'السياسات',
  },
  login: {
    linkHelperText: 'إنشاء حساب',
    linkHelperMessage: 'ليس لديك حساب؟',
    title: 'تسجيل الدخول',
    forgot_password: 'هل نسيت كلمة المرور؟',
    remember: 'تذكرني',
    input_email_placeholder: 'البريد الإلكتروني',
    input_password_placeholder: 'كلمة المرور',
    required_email: 'البريد الإلكتروني مطلوب',
    inValid_email: 'البريد الإلكتروني غير صالح',
    required_password: 'كلمة المرور مطلوبة',
    continue_with: 'المتابعة باستخدام',
  },
  forgot_password: {
    linkHelperText: 'إنشاء حساب',
    linkHelperMessage: 'العودة إلى ',
    title: 'إعادة تعيين كلمة المرور',
    text: 'سنرسل كلمة مرور جديدة إلى حسابك عبر البريد الإلكتروني',
    input_email_placeholder: 'البريد الإلكتروني',
    required_email: 'البريد الإلكتروني مطلوب',
  },
  reset_password: {
    linkHelperText: 'تسجيل الدخول',
    linkHelperMessage: 'تعرف على كلمة المرور؟',
    title: 'كلمة مرور جديدة',
    input_password_placeholder: 'كلمة مرور جديدة',
    input_password_confirm_placeholder: 'تأكيد كلمة المرور الجديدة',
    text: 'أرسل بريدك الإلكتروني لإعادة تعيين كلمة المرور وإنشاء كلمة مرور جديدة',
    required_password: 'كلمة المرور مطلوبة',
    required_password_confirem: 'تأكيد كلمة المرور مطلوب',
    not_same_passwords: 'تأكيد كلمة المرور غير مطابق لكلمة المرور',
  },
  sidebar: {
    dashboard: 'لوحة التحكم',
    services: 'الخدمات',
    requests: 'الطلبات',
    billing: 'الفواتير',
    fqa: 'الأسئلة الشائعة',
    documentation: 'التوثيق',
    settings: 'الإعدادات',
    pricing: 'الأسعار',
    Panel: 'لوحة التحكم',
    Playground: 'منطقة التجربة',
    resume: 'السيرة الذاتية',
    resumeParser: 'محلل',
    resumeReview: 'مراجعة',
    resumeScore: 'درجة',
    youtube: 'يوتيوب',
    youtubeSEO: 'تحسين محركات البحث',
    youtubeKeyword: 'أداة كلمات مفتاحية',
    youtubeTitle: 'مولد عناوين',
    youtubeDescription: 'مولد أوصاف',
    youtubeHashtags: 'هاشتاجات',
    data: 'البيانات',
    dataLinkedInProfile: 'الملف الشخصي',
    dataLinkedInCompany: 'الشركة',
    resumeServices: 'خدمات السيرة الذاتية',
    dataServices: 'خدمات البيانات',
    whatsNew: `ما الجديد`,
  },
  not_found: {
    title: 'الصفحة غير موجودة',
    first_text: 'نعتذر، الصفحة التي طلبتها غير موجودة.',
    second_text: 'يرجى العودة إلى الصفحة الرئيسية',
  },
  internal_error: {
    title: 'عذرًا! حدث خطأ ما',
    first_text: 'خطأ في الخادم 500. نعتذر ونعمل على حل المشكلة.',
    second_text: 'يرجى المحاولة مرة أخرى في وقت لاحق',
  },
  api_key: {
    api_key: 'مفتاح API',
    api_key_text:
      'مفتاح API هو معرف فريد سيمكنك من الوصول إلى واجهاتنا البرمجية ودمج خدماتنا في تطبيقاتك بسهولة.',
    api_key_alert:
      'نظهر هذا لك مرة واحدة فقط. إذا نسيت ذلك، ستحتاج إلى إنشاء مفتاح جديد.',
  },
  latest_requests: {
    latest_requests: 'أحدث الطلبات',
    services_name: 'اسم الخدمات',
    date: 'التاريخ',
    time: 'الوقت',
  },
  total_tokens: {
    total_tokens: 'إجمالي الأرصدة',
  },
  payment: {
    order_summery: 'ملخص الطلب',
    credits: 'أرصدة',
    per_month: '/ شهريًا',
    payment_methods: 'اختر طريقة الدفع الخاصة بك',
    cryptocurrency: 'العملات الرقمية',
    credit_card: 'بطاقة ائتمان / بطاقة خصم',
    order_summery_text:
      'راجع الخطة التي اخترتها وأكمل عملية الشراء. احصل على نظرة شاملة على خطتك المختارة قبل المتابعة.',
    monthly_access: 'الوصول الشهري',
    selected_plan: 'الخطة المحددة هي',
    amount_due: 'المبلغ المستحق خلال 7 أيام',
    amount_due_today: 'المبلغ المستحق اليوم',
  },
  cryptocurrency: {
    required_coin: 'العملة مطلوبة',
    input_selected_coin_placeholder: 'اختر العملة',
  },
  credit_card: {
    credit_card_coming_soon: 'قريبًا...',
    credit_card_coming_soon_text:
      'نعمل بجد على توفير إمكانية الدفع باستخدام البطاقات الائتمانية. ترقبوا طريقة الدفع الجديدة قريبًا لتوسيع خياراتكم.',
  },
  payment_success: {
    title: 'تمت عملية الدفع بنجاح',
    text: 'شكرًا لاختيارك MagicalAPI',
    processing_your_title: 'جارٍ معالجة اشتراكك...',
    processing_your_text: 'يرجى الانتظار، نحن نعالج اشتراكك',
    subscription_activated_title: 'تم تفعيل اشتراكك الآن.',
    subscription_activated_button: 'لنبدأ',
    being_processed_title: 'جارٍ معالجة اشتراكك',
    being_processed_text:
      'يتم التعامل مع دفعتك بشكل آمن، وسنقوم بإبلاغك فور اكتمالها.',
    being_processed_button: 'الذهاب إلى لوحة التحكم',
  },
  payment_failed: {
    title: 'يرجى المحاولة مرة أخرى',
    title: 'رصيدك نفد',
    text: 'ليس لديك أرصدة كافية لإتمام هذه العملية',
  },
  login_modal: {
    welcome_to_the: 'مرحبًا بك في',
    magicalapi: 'MagicalAPI',
    text: 'سجل الدخول باستخدام حسابك في MagicalAPI للمتابعة',
  },
  youtube_suggestion: {
    title: 'اقتراحات يوتيوب',
    example_input_suggestion: 'مثال: كيفية إنشاء متجر Shopify مربح',
    input_suggestion_placeholder: 'وصف محتوى فيديو اليوتيوب الخاص بك',
    input_goal_placeholder: 'اختر هدفًا: ',
    input_number_placeholder: 'عدد النتائج: ',
    required_description: 'وصف الفيديو مطلوب',
    minimum_description: 'وصف الفيديو قصير جدًا (الحد الأدنى 10 أحرف)',
    maximum_description: 'وصف الفيديو طويل جدًا (الحد الأقصى 500 حرف)',
    required_goal: 'الهدف مطلوب',
    required_number: 'عدد النتائج مطلوب',
    minimum_count_description: 'الحد الأدنى: 1، الحد الأقصى: 3',
    minimum_count_title: 'الحد الأدنى: 2، الحد الأقصى: 10',
    minimum_count_hashtags: 'الحد الأدنى: 5، الحد الأقصى: 20',
    minimum_count_keywords: 'الحد الأدنى: 5، الحد الأقصى: 20',
    maximum_count_description: 'الحد الأدنى: 1، الحد الأقصى: 3',
    maximum_count_title: 'الحد الأدنى: 2، الحد الأقصى: 10',
    maximum_count_hashtags: 'الحد الأدنى: 5، الحد الأقصى: 20',
    maximum_count_keywords: 'الحد الأدنى: 5، الحد الأقصى: 20',
  },
  youtube_title: {
    discribe_videos: 'وصف الفيديو:',
    tone: 'النغمة:',
    title: 'مولد عناوين يوتيوب',
    example_input_suggestion: 'مثال: ss',
    input_suggestion_placeholder: 'وصف محتوى فيديو يوتيوب الخاص بك',
    input_goal_placeholder: 'اختر نغمة: ',
    input_number_placeholder: 'عدد النتائج: ',
    required_description: 'وصف الفيديو مطلوب',
    minimum_description: 'وصف الفيديو قصير جدًا (الحد الأدنى 10 أحرف)',
    maximum_description: 'وصف الفيديو طويل جدًا (الحد الأقصى 500 حرف)',
    required_goal: 'الهدف مطلوب',
    required_tone: 'النغمة مطلوبة',
    required_number: 'عدد النتائج مطلوب',
    minimum_count_description: 'الحد الأدنى: 1، الحد الأقصى: 3',
    minimum_count_title: 'الحد الأدنى: 2، الحد الأقصى: 10',
    minimum_count_hashtags: 'الحد الأدنى: 5، الحد الأقصى: 20',
    minimum_count_keywords: 'الحد الأدنى: 5، الحد الأقصى: 20',
    maximum_count_description: 'الحد الأدنى: 1، الحد الأقصى: 3',
    maximum_count_title: 'الحد الأدنى: 2، الحد الأقصى: 10',
    maximum_count_hashtags: 'الحد الأدنى: 5، الحد الأقصى: 20',
    maximum_count_keywords: 'الحد الأدنى: 5، الحد الأقصى: 20',
    get_titles: 'احصل على العناوين',
  },
  youtube_description: {
    discribe_videos: 'وصف الفيديو:',
    tone: 'النغمة:',
    title: 'مولد أوصاف يوتيوب',
    example_input_suggestion: 'مثال: ss',
    input_suggestion_placeholder: 'وصف محتوى فيديو يوتيوب الخاص بك',
    input_goal_placeholder: 'اختر نغمة: ',
    input_number_placeholder: 'عدد النتائج: ',
    required_description: 'وصف الفيديو مطلوب',
    minimum_description: 'وصف الفيديو قصير جدًا (الحد الأدنى 10 أحرف)',
    maximum_description: 'وصف الفيديو طويل جدًا (الحد الأقصى 500 حرف)',
    required_goal: 'الهدف مطلوب',
    required_tone: 'النغمة مطلوبة',
    required_number: 'عدد النتائج مطلوب',
    minimum_count_description: 'الحد الأدنى: 1، الحد الأقصى: 3',
    minimum_count_title: 'الحد الأدنى: 2، الحد الأقصى: 10',
    minimum_count_hashtags: 'الحد الأدنى: 5، الحد الأقصى: 20',
    minimum_count_keywords: 'الحد الأدنى: 5، الحد الأقصى: 20',
    maximum_count_description: 'الحد الأدنى: 1، الحد الأقصى: 3',
    maximum_count_title: 'الحد الأدنى: 2، الحد الأقصى: 10',
    maximum_count_hashtags: 'الحد الأدنى: 5، الحد الأقصى: 20',
    maximum_count_keywords: 'الحد الأدنى: 5، الحد الأقصى: 20',
    get_descriptions: 'احصل على الأوصاف',
  },
  youtube_hashtags: {
    enter_keyword: 'أدخل الكلمة المفتاحية:',
    warning_lenght: 'للحصول على نتائج مثلى، يرجى إدخال موضوع أو كلمة مفتاحية.',
    title: 'هاشتاجات يوتيوب',
    example_input_suggestion: 'مثال: ss',
    input_suggestion_placeholder: 'أدخل',
    input_goal_placeholder: 'اختر نغمة: ',
    input_number_placeholder: 'عدد النتائج: ',
    required_description: 'وصف الفيديو مطلوب',
    minimum_description: 'الكلمة المفتاحية قصيرة جدًا (الحد الأدنى 3 أحرف)',
    maximum_description: 'الكلمة المفتاحية طويلة جدًا (الحد الأقصى 50 حرف)',
    required_goal: 'الهدف مطلوب',
    required_tone: 'النغمة مطلوبة',
    required_number: 'عدد النتائج مطلوب',
    minimum_count_description: 'الحد الأدنى: 1، الحد الأقصى: 3',
    minimum_count_title: 'الحد الأدنى: 2، الحد الأقصى: 10',
    minimum_count_hashtags: 'الحد الأدنى: 5، الحد الأقصى: 20',
    minimum_count_keywords: 'الحد الأدنى: 5، الحد الأقصى: 20',
    maximum_count_description: 'الحد الأدنى: 1، الحد الأقصى: 3',
    maximum_count_title: 'الحد الأدنى: 2، الحد الأقصى: 10',
    maximum_count_hashtags: 'الحد الأدنى: 5، الحد الأقصى: 20',
    maximum_count_keywords: 'الحد الأدنى: 5، الحد الأقصى: 20',
    get_hashtags: 'احصل على الهاشتاجات',
    alert_length:
      'للحصول على نتائج مثلى، يرجى إدخال موضوع أو كلمة مفتاحية من كلمتين أو أقل.',
  },
  youtube_keyword: {
    enter_keyword: 'أدخل الكلمة المفتاحية:',
    title: 'أداة الكلمات المفتاحية ليوتيوب',
    tags: '(علامات)',
    example_input_keyword:
      'أمثلة: ماينكرافت، مقاطع فيديو موسيقية، عروض أفلام، إلخ.',
    input_keyword_placeholder: 'أدخل الكلمة المفتاحية',
    input_country_placeholder: 'اختر بلدًا',
    input_language_placeholder: 'اختر لغة',
    required_keyword: 'الكلمة المفتاحية مطلوبة',
    country_require: 'البلد مطلوب',
    language_require: 'اللغة مطلوبة',
    minimum_keyword: 'الكلمة المفتاحية قصيرة جدًا (الحد الأدنى 3 أحرف)',
    maximum_keyword: 'الكلمة المفتاحية طويلة جدًا (الحد الأقصى 50 حرف)',
  },
  resume_score: {
    title: 'مطابق السيرة الذاتية',
    subtitle: 'طابق سيرتك الذاتية مع أوصاف الوظائف',
    description: 'احصل على درجة مطابقة مفصلة وحسن فرصك في التوظيف',
    required_resume: 'السيرة الذاتية مطلوبة',
    required_skills: 'المهارات مطلوبة',
    required_JobDescription: 'وصف الوظيفة مطلوب',
    minimum_description: 'وصف الوظيفة قصير جدًا (الحد الأدنى 100 حرف)',
    maximum_description: 'وصف الوظيفة طويل جدًا (الحد الأقصى 5000 حرف)',
    file_size_maximum: 'الحد الأقصى لحجم الملف المسموح به هو 10 ميغابايت',
    type_file_error: 'يدعم فقط ملفات PDF و DOCX و DOC',
    file: 'تحميل',
    url: 'رابط',
    file_url_label: 'الصق رابط الملف',
    input_file_placeholder: 'اختر ملفًا',
    input_url_placeholder: 'أدخل رابط https://...',
    required_resume_url: 'رابط ملف السيرة الذاتية مطلوب',
    invalid_url: 'رابط وصف الوظيفة غير صحيح',
  },
  resume_parser: {
    title: 'محلل السيرة الذاتية',
    subtitle: 'قم بتحميل سيرتك الذاتية واستخرج كافة البيانات فوراً',
    description: 'استخرج الحقول الأساسية في ثوانٍ وقم بتبسيط سير عملك',
    required_resume: 'ملف السيرة الذاتية مطلوب',
    required_resume_url: 'رابط ملف السيرة الذاتية مطلوب',
    file_size_maximum: 'الحد الأقصى لحجم الملف المسموح به هو 10 ميغابايت',
    type_file_error: 'يدعم فقط ملفات PDF و DOCX و DOC',
    file: 'تحميل',
    url: 'رابط',
    file_url_label: 'الصق رابط الملف',
    input_file_placeholder: 'اختر ملفًا',
    input_url_placeholder: 'أدخل رابط https://...',
  },
  youtube_seo: {
    title: 'تحسين محركات البحث ليوتيوب',
    required_resume: 'ملف السيرة الذاتية مطلوب',
    required_resume_url: 'رابط الفيديو مطلوب',
    file_size_maximum: 'الحد الأقصى لحجم الملف المسموح به هو 10 ميغابايت',
    type_file_error: 'يدعم فقط ملف PDF',
    file: 'تحميل',
    url: 'رابط',
    input_file_placeholder: 'اختر ملفًا',
    input_url_placeholder: 'أدخل رابط https://...',
    invalid_url: 'رابط الفيديو غير صحيح',
    watch_example: 'https://youtube.com/watch?v=VIDEO_ID',
    short_example: 'https://youtube.com/shorts/VIDEO_ID',
  },
  resume_review: {
    title: 'فحص السيرة الذاتية',
    subtitle: 'قم برفع سيرتك الذاتية للحصول على تحليل شامل',
    description:
      'احصل على ملاحظات شاملة ورؤى قابلة للتنفيذ لتحسين سيرتك الذاتية',
    required_resume: 'ملف السيرة الذاتية مطلوب',
    required_resume_url: 'رابط ملف السيرة الذاتية مطلوب',
    file_size_maximum: 'الحد الأقصى لحجم الملف المسموح به هو 10 ميغابايت',
    type_file_error: 'يدعم فقط ملفات PDF و DOCX و DOC',
    file: 'تحميل',
    url: 'رابط',
    file_url_label: 'الصق رابط الملف',
    input_file_placeholder: 'اختر ملفًا',
    input_url_placeholder: 'أدخل رابط https://...',
  },
  profile_data: {
    linkedin_profile: 'رابط ملف لينكد إن:',
    title: 'بيانات الملف الشخصي',
    subtitle: 'استخرج البيانات من أي ملف شخصي على لينكد إن',
    description: 'احصل على التفاصيل المهنية والرؤى في ثوانٍ.',
    required_username: 'رابط ملف لينكد إن مطلوب',
    input_username_placeholder: 'رابط ملف لينكد إن',
    invalid_linkedin_url: 'رابط لينكد إن غير صالح',
  },
  company_data: {
    title: 'بيانات الشركة',
    subtitle: 'احصل على بيانات شاملة عن أي شركة',
    description: 'استخرج تفاصيل مثل الصناعة والحجم والموقع من لينكد إن.',
    required_companyname: 'رابط ملف لينكد إن للشركة مطلوب',
    input_placeholder: 'رابط لينكد إن للشركة',
    invalid_linkedin_url: 'رابط لينكد إن غير صالح',
    company_website: 'موقع الشركة',
    company_name: 'اسم الشركة',
    linkedin_url: 'رابط لينكد إن للشركة',
    company_name_switch: 'الاسم',
    company_website_switch: 'الموقع الإلكتروني',
    linkedin_url_switch: 'رابط الملف الشخصي',
  },
  magical_resume_score: {
    title: 'مطابق السيرة الذاتية السحري',
    required_resume: 'السيرة الذاتية مطلوبة',
    file_size_maximum: 'الحد الأقصى لحجم الملف المسموح به هو 10 ميغابايت',
    type_file_error: 'يدعم فقط ملفات PDF و DOCX و DOC',
    required_skills: 'المهارات مطلوبة',
    file: 'تحميل',
    url: 'رابط',
    input_file_placeholder: 'اختر ملفًا',
    input_url_placeholder: 'أدخل رابط https://...',
    input_linkedin_profile_name_placeholder: 'اسم ملف لينكد إن',
  },
  get_more_credits: {
    get_more_credits: 'احصل على المزيد من الاعتمادات',
    select_credits_you_need: 'اختر الاعتمادات التي تحتاجها',
  },
  get_more_credits_page: {
    get_more_credits: 'Get More Credits',
    select_amount_to_buy: 'Select the amount of credits you want to buy',
    buy_now_button: 'Buy Now',
    details_box_title: 'Details',
    details_box_credits_lbl: 'Credits',
    details_box_price_lbl: 'Price',
    details_box_total_amount_lbl: 'Total amount',
  },
  invoice_table: {
    invoices: 'الفواتير',
    invoice_id: 'رقم الفاتورة',
    date: 'التاريخ',
    amount: 'المبلغ',
    plan: 'الخطة',
    status: 'الحالة',
    action: 'الإجراء',
    pending: 'قيد الانتظار',
    paid: 'مدفوع',
    failed: 'فشل',
    month: 'شهر',
  },
  invoice_details: {
    title: 'تفاصيل الفاتورة',
    payment_for: 'الدفع من أجل',
    date: 'تاريخ الإنشاء',
    plan: 'الخطة',
    tax: 'الضريبة',
    discount: 'الخصم',
    total_amount: 'المبلغ الإجمالي',
    status: 'الحالة',
    payment_date: 'تاريخ الدفع',
    ok_btn: 'موافق',
    download_pdf_btn: 'تنزيل PDF',
    credits_per_month: 'أرصدة/شهر',
    paid: 'مدفوع',
    failed: 'فشل',
  },
  month: {
    jan: 'يناير',
    feb: 'فبراير',
    mar: 'مارس',
    apr: 'أبريل',
    may: 'مايو',
    jun: 'يونيو',
    jul: 'يوليو',
    aug: 'أغسطس',
    sep: 'سبتمبر',
    oct: 'أكتوبر',
    nov: 'نوفمبر',
    dec: 'ديسمبر',
  },
  service_chart: {
    last_month: 'الماه القبل',
    last_year: 'السال القبل',
    dropdown_placeholder: 'الماه القبل',
  },
  fallback: {
    title: 'عذرًا! حدث خطأ ما',
    subtitle: 'خطأ في الخادم 500. نعتذر ونقوم بإصلاح المشكلة.',
    text: 'يرجى المحاولة مرة أخرى في وقت لاحق',
    contact_support: 'الاتصال بالدعم',
    reload_page: 'إعادة تحميل الصفحة',
  },
  menu_help: {
    online_support: 'الدعم عبر الإنترنت',
    contact_us: 'اتصل بنا',
    request_feature: 'طلب ميزة',
    join_discord: 'انضم إلى ديسكورد',
  },
  plan_info: {
    your_plan: 'خطتك هي',
    left_until: 'المتبقي حتى',
    used: 'المستخدم',
    total_credits: 'إجمالي الرصيد',
    credits: 'أرصدة',
    next_bill: 'الفاتورة القادمة في',
    on: 'في',
    credits_month: 'أرصدة/شهر',
    current: 'الحالي',
    plan: 'الخطة',
    cancel_subscription: 'إلغاء الاشتراك',
    credits_used: 'الأرصدة المستخدمة',
    renewed_at: 'تم التجديد في',
    billing_period: 'فترة الفوترة',
  },
  trial_plan: {
    trial_plan_active: 'خطة التجربة نشطة',
    explore_features: 'استكشف جميع المميزات المتقدمة',
    days_left: 'أيام متبقية',
    trial_ends_on: 'تنتهي التجربة في',
    whats_included: 'ما هو مشمول في تجربتك:',
    credits: 'أرصدة',
    all_services_access: 'الوصول إلى جميع الخدمات',
    available_for_days: 'متاحة لمدة {{days}} أيام',
    credits_used: 'الأرصدة المستخدمة',
    upgrade_to_pro: 'الترقية إلى برو',
    compare_plans: 'مقارنة الخطط',
  },
  description_services_suggestion: {
    company_data: 'هل ترغب في الحصول على بيانات <span>صفحة الشركة</span>؟',
    youtube_keyword:
      'هل ترغب في الحصول على <span>مشاهدات أكثر</span> على <span>يوتيوب</span>؟',
    profile_data: 'هل ترغب في استكشاف <span>رؤى ملف لينكد إن</span>؟',
    resume_parser:
      'هل ترغب في استخراج البيانات من <span>ملف السيرة الذاتية</span>؟',
    resume_review: 'هل ترغب في تحليل <span>سيرتك الذاتية</span>؟',
    resume_score:
      'هل ترغب في مقارنة <span>سيرتك الذاتية</span> مع <span>وظيفة</span>؟',
    youtube_seo:
      'هل ترغب في التحقق من <span>تحسين محركات البحث للفيديو</span>؟',
    youtube_suggestions: 'هل ترغب في تحسين <span>محتوى يوتيوب الخاص بك</span>؟',
    youtube_title: 'هل ترغب في تحسين <span>عنوان يوتيوب الخاص بك</span>؟',
    youtube_description: 'هل ترغب في تحسين <span>وصف يوتيوب الخاص بك</span>؟',
    youtube_hashtags:
      'هل ترغب في تحسين <span>الهاشتاجات الخاصة بك على يوتيوب</span>؟',
  },
  pricing: {
    monthly: 'شهري',
    yearly: 'سنوي',
    save: 'احفظ',
    start_your: 'ابدأ تجربتك',
    free_trial: 'تجربة مجانية',
    trial_info: '2000 اعتماد في 7 أيام',
    most_popular: 'الأكثر شعبية',
    per_month: 'لكل شهر',
    current_plan: 'الخطة الحالية',
    try_for_free: 'جرّب مجانًا',
    business: 'الأعمال',
    business_description:
      'مثالي للشركات التي تحتاج إلى اعتمادات إضافية ودعم كامل. تواصل مع فريق المبيعات لدينا للحصول على حلول مخصصة وامتيازات خاصة.',
    contact_sales: 'الاتصال بالمبيعات',
    request_demo: 'الدمو الدرخواست',
    account_features: 'ميزات الحساب',
    each_request_uses: 'كل طلب يستخدم',
    credits: 'اعتمادات',
    request: 'طلبات/شهر',
    limited_response: 'استجابة محدودة',
    buy_now: 'اشترِ الآن',
  },
  profile: {
    setting: 'الإعدادات',
    profile: {
      first_name: 'الاسم الأول',
      last_name: 'اسم العائلة',
      display_name: 'اسم العرض',
      email_address: 'عنوان البريد الإلكتروني',
      signup_date: 'تاريخ التسجيل',
    },
    tab: {
      account_info: 'معلومات الحساب',
      payment: 'الدفع',
    },
    payment: {
      next_plan: 'الخطة التالية',
      monthly: 'شهري',
      activate_now: 'تفعيل الآن',
      current_plan: 'الخطة الحالية',
      compare_plans: 'مقارنة الخطط',
      received: 'تم الاستلام',
      expires: 'تنتهي',
      credits: 'اعتمادات',
      ends_at: 'تنتهي عند',
      next_billed_on: 'سيتم الفوترة التالية في',
      your_subscription: 'جارٍ معالجة اشتراكك',
      subscription_activated: 'تم تفعيل الاشتراك بنجاح!',
      activate_plan: 'تفعيل الخطة',
      active_plan_one: 'هل أنت متأكد أنك تريد إنهاء خطة التجربة؟',
      active_plan_two: 'لا يمكن إلغاء هذا الإجراء',
      active_plan_three: 'غير قابل للتراجع',
      stay_trial: 'البقاء في التجربة',
      yes_activate: 'نعم، فعله',
      manage_subscription: 'إدارة اشتراكك',
      manage_subscription_text:
        'سيبقى اشتراكك الحالي نشطًا حتى نهاية فترة الفوترة، مما يتيح لك الاستمرار في الاستمتاع بخدماتنا حتى ذلك الحين. يرجى ملاحظة أن هذا الإجراء لن يصدر رد الأموال لفترة الاشتراك الحالية، ولكنه سيضمن عدم تجديد اشتراكك تلقائيًا.',
      cancel_renewal: 'إلغاء التجديد',
      cancel_renewal_text_one: 'هل أنت متأكد أنك تريد إلغاء اشتراكك؟',
      cancel_renewal_text_two: 'لا يمكن إلغاء هذا الإجراء',
      cancel_renewal_text_tree: 'غير قابل للتراجع',
      stay_subscribed: 'ابق مشتركًا',
      yes_cancel: 'نعم، ألغِه',
      change_profile: 'تغيير صورة الملف الشخصي في',
      gravatar: 'Gravatar',
    },
  },
  services_page: {
    credit_request: 'اعتماد لكل طلب',
    pricing: 'التسعير',
    total_requests: 'إجمالي الطلبات',
  },
  upgrade_box: {
    try: 'جرّب',
    plan_free: 'خطة مجانية',
    upgrade_to: 'ترقية إلى',
    starting_trial_plan:
      'ابدأ خطة التجربة الآن مجانًا للحصول على جميع البيانات!',
    basic_plan_text:
      'قم بالترقية إلى خطة أساسية الآن للحصول على جميع البيانات!',
    start_free: 'ابدأ مجانًا',
    active_trial: 'تفعيل التجربة',
    upgrade_now: 'قم بالترقية الآن',
    upgrade_to_plan: 'ترقية إلى {{planName}}',
    plan_label: 'خطة {{planName}}',
    features: {
      premium_features: 'افتح الميزات الممتازة والرؤى المتقدمة<span class="instantly-text"> فورًا</span>.',
      no_credit_card: 'لا تتطلب بطاقة ائتمان، إلغاء في أي وقت.',
      all_services_access: 'الوصول إلى جميع خدمات Magical API.',
      free_credits_trial: 'احصل على ٢٠٠٠ رصيد مجاني لمدة ٧ أيام.',
    },
    upgrade_basic: 'ترقية إلى الخطة الأساسية',
    try_for_free: 'جرّب مجانًا',
    upgrade_pro: 'ترقية إلى الخطة الاحترافية',
  },
  free_plan: {
    your_plan: 'خطتك هي',
    upgrade_to: 'ترقية إلى',
    plan: 'خطة',
    try: 'جرّب',
    every_thing: 'كل شيء في الخطة المجانية، و:',
    compare_plans: 'مقارنة الخطط',

    credits: '٢٠٠٠ رصيد',
    services_access: 'الوصول إلى جميع الخدمات',
    availability: 'متاح لمدة ٧ أيام',
  },

  updating: {
    title: 'نقوم بتحديث نظامنا',
    first_text: 'نأسف، لم يتم العثور على الصفحة التي طلبتها.',
    second_text: 'يرجى العودة إلى الصفحة الرئيسية',
  },
  product: {
    data: 'بيانات سحرية',
    resume: 'سيرة ذاتية سحرية',
    youtube: 'يوتيوب سحري',
    data_single: 'بيانات',
    resume_single: 'سيرة ذاتية',
    youtube_single: 'يوتيوب',
  },
  manual_invoices: {
    order_summary_title: 'تفاصيل الفاتورة',
    amount_due_title: 'المبلغ المستحق',
  },
  drag_drop: {
    drag_drop_text: 'اسحب وأسقط سيرتك الذاتية هنا أو',
    click_to_upload: 'انقر للتحميل',
    remove_file: 'إزالة الملف',
    upload_your_resume: 'ارفع سيرتك الذاتية',
    accepted_file_types: 'أنواع الملفات المقبولة: PDF, DOCX, DOC (10 ميجابايت)',
  },
};
export default ar;
